// extracted by mini-css-extract-plugin
module.exports = {"video":"youtubePlayer-module--video--1cM1Y","iframe":"youtubePlayer-module--iframe--2Y8DD"};